import axios from '@/services/request';
import {AxiosPromise} from "axios";
import store from "@/store";
// @ts-ignore
import qs from 'qs'
import {AdCreateInfo} from "@/model/AdCreateInfo";
import {Account, AccountReq, AccountStatusReq} from "@/model/Account";
import {Resp, Page, Resp2} from "@/model/Resp";
import {
  OverviewReq,
  OverviewResp,
  ReportOnlineReq,
  ReportOnlineResp,
  ReportOrderReq,
  ReportOrderResp
} from "@/model/Report";

/**
 * 登录
 * @param params
 * @param showLoading
 */
export function login(params: {
  userName: string,   // 用户
  password: string    // 密码
}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/user/login`, params)
}

/**
 * 登出
 * @param params
 * @param showLoading
 */
export function logout(params: {
}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/user/logout`, {params})
}


/**
 * 获取登录用户信息
 * @param params
 * @param showLoading
 */
export function userInfo(params: {
}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/user/baseInfo`, {params})
}

/**
 * 编辑工具item列表
 * @param params
 * @param showLoading
 */
export function getEditItemList(params: {
  country?: string,
  language?: string,
  itemId?: number,
  tempLinkUrl?: string,
  creater?: string,
  startDate?: string,
  endDate?: string,
  currency?: string,
  pageNo: number,
  pageSize: number
}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/itemList`, params)
}

/**
 * 站点列表
 * @param params
 * @param showLoading
 */
export function getStationList(params: {
  country?: string,
  title?: string,
  itemId?: number,
  pageNo: number,
  pageSize: number
}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/staticPages`, params)
}

/**
 * 本人item列表
 * @param params
 * @param showLoading
 */
export function getMyItemList(params: {
  country?: string,
  language?: string,
  itemId?: number,
  tempLinkUrl?: string,
  startDate?: string,
  endDate?: string,
  currency?: string,
  pageNo: number,
  pageSize: number
}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/myItemList`, params)
}

/**
 * id获取item详情
 * @param copyItemId
 * @param showLoading
 */
export function getDetailById(copyItemId: number, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/genData`,  {copyItemId})
}

/**
 * url获取item详情
 * @param linkURL
 * @param showLoading
 */
export function getDetailByUrl(linkURL: string, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/genData`, {linkURL})
}

/**
 * 产品码获取item详情
 * @param itemHash
 * @param showLoading
 */
export function getDetailByHash(itemHash: string, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/genDataByHash`, {itemHash})
}

/**
 * item修改
 * @param params
 * @param showLoading
 */
export function saveEditItemDetail(params: any, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/saveData`, params)
}

/**
 * 拷贝item
 * @param params
 * @param showLoading
 */
export function copyItem(params: {copyItemId: number, country: string}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/copyData`, params)
}

/**
 * 获取配置
 * @param params
 * @param showLoading
 */
export function getConfig(params: {
  type: 'region'|'language'|'toushou'|'domain'|'accountPageStatus'|'orderStatus'
}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/config/datas`, {params})
}

/**
 * 保存落地页信息
 * @param params
 * @param showLoading
 */
export function saveLangdingPage(params: any, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/landingPage`, params)
}

/**
 * 修改像素
 * @param params
 * @param showLoading
 */
export function updatePixel(params: any, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/updatePixel`, params)
}

/**
 * 新增域名
 * @param params
 * @param showLoading
 */
export function addDomain(params: {domain: string}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/manage/add`, {params})
}


/**
 * 删除域名
 * @param params
 * @param showLoading
 */
export function deleteDomain(params: {domain: string}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/manage/delete`, {params})
}

/**
 * 创建广告
 * @param params
 * @param showLoading
 */
export function createAd(params: AdCreateInfo, showLoading: boolean = true): AxiosPromise<Resp<AdCreateInfo>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/facebookDeliver/ad/createAd`, params)
}

/**
 * 根据pixel获取账号列表
 * @param params
 * @param showLoading
 */
export function getAccountList(params: {pixelId: string}, showLoading: boolean = false): AxiosPromise<Resp<{code: string, desc: string, available: boolean}[]>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/facebookDeliver/ad/accountList`, {params})
}

/**
 * 根据账号获取page列表
 * @param params
 * @param showLoading
 */
export function getPageList(params: {accountId: string}, showLoading: boolean = false): AxiosPromise<Resp< {code: string, desc: string}[]>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/facebookDeliver/ad/pageList`, {params})
}

/**
 * 获取我的账户列表
 * @param params
 * @param showLoading
 */
export function getMyAccountList(params: AccountReq, showLoading: boolean = false): AxiosPromise<Resp<Page<Account>>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/facebookDeliver/account/myAccountList`, {params})
}

/**
 * 验证账户
 * @param params
 * @param showLoading
 */
export function verifyAccountStatus(params: AccountStatusReq, showLoading: boolean = false): AxiosPromise<Resp<string>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/facebookDeliver/account/verifyStatus`, params)
}

/**
 * 停用账户
 * @param params
 * @param showLoading
 */
export function stopAccount(params: AccountStatusReq, showLoading: boolean = false): AxiosPromise<Resp<string>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/facebookDeliver/account/stopAccount`, params)
}

/**
 * 删除账户
 * @param params
 * @param showLoading
 */
export function deleteAccount(params: AccountStatusReq, showLoading: boolean = false): AxiosPromise<Resp<string>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/facebookDeliver/account/deleteAccount`, params)
}

/**
 * 获取excel模板
 */
export function getTempExcel(params: {}, showLoading: boolean = false): AxiosPromise<Resp<File>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios({
    url: `/api/facebookDeliver/excel/temp/downloadAccountPage`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}

/**
 * 上传文件接口
 * @param params
 * @param showLoading
 */
export function uploadAccountPage(params: FormData, showLoading: boolean = true): AxiosPromise<Resp<any>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/facebookDeliver/excel/upload/accountPage`, params)
}

/**
 * 图片查重
 * @param params
 * @param showLoading
 */
export function checkDuplicate(params: {itemId: number, country: string, image: string}, showLoading: boolean = true): AxiosPromise<Resp2<any[]>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/similar/itemByImage`, params)
}

/**
 * 数据总览
 * @param params
 * @param showLoading
 */
export function getOverviewList(params: OverviewReq, showLoading: boolean = true): AxiosPromise<Resp<Page<OverviewResp>>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/report/overviewList`, {params})
}

/**
 * 订单数据
 * @param params
 * @param showLoading
 */
export function getOrderList(params: ReportOrderReq, showLoading: boolean = true): AxiosPromise<Resp<Page<ReportOrderResp>>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/report/orderList`, {params})
}

/**
 * 在投数据
 * @param params
 * @param showLoading
 */
export function getOnlineList(params: ReportOnlineReq, showLoading: boolean = true): AxiosPromise<Resp<Page<ReportOnlineResp>>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/report/onlineList`, {params})
}

/**
 * 获取excel
 */
export function getOverviewExcel(params: OverviewReq, showLoading: boolean = false): AxiosPromise<Resp<File>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios({
    url: `/api/report/overviewExcel`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}
export function getOrderExcel(params: ReportOrderReq, showLoading: boolean = false): AxiosPromise<Resp<File>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios({
    url: `/api/report/orderExcel`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}
export function getOnlineExcel(params: ReportOnlineReq, showLoading: boolean = false): AxiosPromise<Resp<File>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios({
    url: `/api/report/onlineExcel`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}

/** 开启自动投放
 * @param params
 * @param showLoading
 */
export function autoPut(params: any, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/delivery/listCreate`, params)
}

/**
 * 自动投放查询
 * @param params
 * @param showLoading
 */
export function getStatusByItemIds(params: any, showLoading: boolean = true): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/delivery/getStatusByItemIds`, params)
}

/**
 * 获取选品数据列表
 * @param params
 * @param showLoading
 * @returns
 */
export function getProdList(params: any, showLoading: boolean = true): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/adlibrary/list`, params)
}
